import actionTypes from './index';

export default itemId => ({ type: actionTypes.ADD_ITEM, payload: { itemId } });
